// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1ic3L","requiredAsterisk":"Info_requiredAsterisk__1L2Rp"};